export const getEnvFromHostname = (host?: string) => {
  const name = (host || '').split('.')[0] || '';
  if (name.startsWith('localhost') || name.endsWith('development')) {
    return 'development';
  }
  if (name.endsWith('staging')) {
    return 'staging';
  }
  if (name.endsWith('nightly')) {
    return 'nightly';
  }
  return 'production';
};
